import React, { useEffect, useMemo, useState } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

import { columns } from './data';
import Table from '../../components/table';
import Topbar from '../../components/topbar';
import Searchbar from '../../components/searchbar';
import CustomSelect from '../../components/select';
import MainLayout from '../../components/mainlayout';
import useGetTransitions from '../../api/queries/useGetTransitions';
import { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST } from '../../utils/constants';

const AllTransactions = () => {
  const [productsData, setProductsData] = useState([]);
  const transactionsQuery = useGetTransitions();
  
  const [transactionData, setTransactionData] = useState([]);
  const [sortOrder, setSortOrder] = useState(SORT_NEWEST_FIRST);
  const [search, setSearch] = useState("");

  const sorted = useMemo(() => {
    const raw = transactionsQuery?.data || [];
  
    // Filter first by seller name
    const filtered = raw.filter(tx => {
      if (!search) return true; // No search -> keep all
      const fullName = `${tx.affected_seller_id?.first_name || ''} ${tx.affected_seller_id?.surname || ''}`.toLowerCase();
      return fullName.includes(search.toLowerCase());
    });
  
    // Then sort by date_created
    const result = [...filtered].sort((a, b) => {
      const dateA = new Date(a?.date_created);
      const dateB = new Date(b?.date_created);
  
      if (sortOrder === SORT_NEWEST_FIRST) {
        return dateB - dateA; // Newest first
      } else {
        return dateA - dateB; // Oldest first
      }
    });
  
    console.log(
      "Filtered + Sorted transactions:",
      result.map(tx => ({
        name: `${tx.affected_seller_id?.first_name} ${tx.affected_seller_id?.surname}`,
        date: tx.date_created
      }))
    );
  
    return result;
  }, [transactionsQuery?.data, sortOrder, search]);
  
  // Update state whenever sorted changes
  useEffect(() => {
    console.log("Setting transactionData with:", sorted.length, "items");
    setTransactionData(sorted);
  }, [sorted]);
  
  return (
    <MainLayout h={'100%'} minH={'100vh'} paddingBottom={20}>
      <Box>
        <Topbar title={'Product Transactions'} />
        <Flex
          bg={'#f8fbff'}
          padding={8}
          height={'100%'}
          gap={2}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Flex align={'center'}>
          <Searchbar onChange={setSearch} title={"Search"} />
          </Flex>
          <Flex justify={'space-between'} alignItems={'center'}>
            <Flex gap={3}>
            <CustomSelect
              label={"Sort"}
              onChange={setSortOrder}
              style={{ maxWidth: "200px" }}
              inputStyle={{
                border: "none",
                background: "#fff",
                color: "#898989",
                fontSize: "14px",
                fontFamily: "PlusJakartaSansMedium",
              }}
            >
              <option value={SORT_NEWEST_FIRST}>Newest First</option>
              <option value={SORT_OLDEST_FIRST}>Oldest First</option>
            </CustomSelect>
            </Flex>
          </Flex>
        </Flex>

        <Box
          minW={'100%'}
          w={'1px'}
          overflowX={'auto'}
          padding={8}
          paddingTop={0}
          bg={'#f8fbff'}
        >
          {transactionsQuery.isLoading ? (
            <Text fontSize="lg">
              Loading Transactions...
            </Text>
          ) : (
            <Table data={transactionData} columns={columns} />
          )}
        </Box>
      </Box>
    </MainLayout>
  );
};

export default AllTransactions;
